import React, { useState, useEffect, useRef } from "react";
import PopupModal from "../../../common/PopupModal";
import AutoComplete from "../../../common/AutoComplete";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAssociateSuggestion,
  fetchAssociationList,
  deleteAssociationList,
  updateAssociationList,
} from "../../../store/Experience/AssociationActions";
import { useLocation } from "react-router-dom";
import "./association.scss";

const Association = ({
  providerId,
  onlyPopup = false,
  openAssociationPopup,
  closePopupCallback = () => {},
}) => {
  const [openPopup, setOpenPopup] = useState(false);
  const [confirmDeleteMap, setConfirmDeleteMap] = useState({});
  const [showError, setShowError] = useState(false);

  const location = useLocation();
  const locationData = location.pathname.split("/");
  const [prvId, setPrvId] = useState(providerId ? providerId : locationData[2]);

  const dispatch = useDispatch();
  const { assSuggestData } = useSelector(
    (state) => state.associationSuggestion
  );

  const { assListData, assListError, assErrorMsg } = useSelector(
    (state) => state.expassociationList
  );

  useEffect(() => {
    if (providerId) {
      setPrvId(providerId);
    } else {
      setPrvId(locationData[2]); 
    }
  }, [providerId]);

  useEffect(() => {
    setOpenPopup(openAssociationPopup);
  }, [openAssociationPopup]);

  useEffect(() => {
    dispatch(
      fetchAssociationList(prvId)
    );
  }, []);

  const addedAssocaitionRef = useRef([]);

  const updateAssociationPayload = (item) => {
    const getAssociation = item.map((item) => {
      return item.name;
    });
    const data = {
      associations: getAssociation,
    };
    return data;
  };

  const toggleConfirmDelete = (displayId, value) => {
    setConfirmDeleteMap((prev) => ({
      ...prev,
      [displayId]: value,
    }));
  };

  const deleteAPiCall = async (displayId) => {
    const getData = await dispatch(
      deleteAssociationList({ providerId: prvId, deleteDisplayID: displayId })
    );
    if (getData?.payload?.success === false) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 2000);
    }
    setConfirmDeleteMap((prev) => ({
      ...prev,
      [displayId]: false,
    }));
    dispatch(fetchAssociationList(prvId));
  };

  const handleClose = () => {
    setTimeout(() => {
      dispatch(fetchAssociationList(prvId));
    }, 20);

    setOpenPopup(!openPopup);
    closePopupCallback();
  };

  const ProviderAssociationAutocomplete = () => {
    return (
      <div>
        <AutoComplete
          suggestions={assSuggestData}
          deleteItem={() => {}}
          renderAddedValues
          autoCompletePlaceHolders="Enter association"
          onValueSelect={(name, values) => {
            addedAssocaitionRef.current = values;
          }}
          name="associations"
          defaultValue={assListData}
          addedValuesHeading="Your Associations"
          label=""
          onValueChangeCallback={(res) => {
            dispatch(fetchAssociateSuggestion(res));
          }}
        />
      </div>
    );
  };

  const RenderAddAssociationPopup = () => {
    return (
      <PopupModal
        isOpen={openPopup}
        onClose={() => {
          setOpenPopup(!openPopup);
          closePopupCallback();
        }}
        enableSave
        onSave={() => {
          dispatch(
            updateAssociationList({
              providerId: prvId,
              data: updateAssociationPayload(addedAssocaitionRef.current),
            })
          ).then(() => {
            return handleClose();
          });
        }}
        customRender={ProviderAssociationAutocomplete}
        popupHeading="Add New Association"
      />
    );
  };

  const RenderAssociationList = () => {
    if (assListData?.length < 1) return null;
    return (
      <>
        {assListData?.map((item) => {
          return (
            <div className="g-col-6 languages-info" key={item.displayId}>
              {item.name}
              <div>
                {confirmDeleteMap[item.displayId] && (
                  <button
                    type="button"
                    className="btn border-0 canceldelete"
                    onClick={() => toggleConfirmDelete(item.displayId, false)}
                  >
                    CANCEL
                  </button>
                )}
                <button
                  type="button"
                  className={`btn ${
                    confirmDeleteMap[item.displayId]
                      ? "deleteConfirmation"
                      : "border-0"
                  }`}
                  onClick={() => {
                    if (confirmDeleteMap[item.displayId]) {
                      deleteAPiCall(item.displayId);
                    } else {
                      toggleConfirmDelete(item.displayId, true);
                    }
                  }}
                >
                  {confirmDeleteMap[item.displayId] ? "CONFIRM" : "DELETE"}
                </button>
              </div>
            </div>
          );
        })}
      </>
    );
  };

  const RenderAssociationError = () => {
    if (!showError) return null;
    return (
      <div className="overlay-alert alert alert-danger" role="alert">
        {assErrorMsg}
      </div>
    );
  };

  const RenderNoAssociationInfo = () => {
    if (assListData.length > 0) return null;

    return (
      <div className="noDataInformationWrapper">
        No associations for this provider
      </div>
    );
  };

  return (
    <div className="association general-Certificate">
      {!onlyPopup && (
        <>
          <h3 className="section-header top-thirty overview">
            Associations{" "}
            {assListData.length > 0 && (
              <span className="edu-count">({assListData.length})</span>
            )}
            <a
              className="btn edit-button"
              onClick={() => {
                setOpenPopup(!openPopup);
              }}
            >
              +Add
            </a>
          </h3>
          {assListError ? (
            <div className="alert alert-danger" role="alert">
              {assErrorMsg}
            </div>
          ) : (
            <>
              {RenderAssociationError()}
              {RenderAssociationList()}
              {RenderNoAssociationInfo()}
            </>
          )}
        </>
      )}
      {openPopup && RenderAddAssociationPopup()}
    </div>
  );
};
export default Association;
